import { createI18n } from 'vue-i18n';

export const i18n = createI18n({
  legacy: true,
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    de: {
      base: {
        headline1: 'Stressless® Tage: <br>Jetzt Sitzkomfort erleben',
        introtext: 'Lassen Sie sich während der Stressless® Tage in der Polsterabteilung umfangreich über die Funktionen, Bezüge und Modelle der Stressless® Sessel und Sofas beraten. Testen Sie den bewährten Stressless® Komfort und entdecken Sie das vielseitige Sortiment. Erfahren Sie von Ihrem Möbelhaus vor Ort an welchen ausgewählten Terminen Stressless® Werksberater zusätzlich die Aktionstage unterstützen.',
        headline2: 'Alle Termine der Stressless® Tage',
        imprint: 'Impressum',
        imprintLink: 'https://www.stressless.com/de-de/impressum',
        dataProtection: 'Datenschutz',
        dataProtectionLink: 'https://www.stressless.com/de-de/impressum/datenschutz',
        contact: 'Kontakt',
        contactLink: 'https://www.stressless.com/de-de/kontakt',
        home: 'stressless.com',
        homeLink: 'https://www.stressless.com/de-de',
      },
      month: {
        1: 'Januar',
        2: 'Februar',
        3: 'März',
        4: 'April',
        5: 'Mai',
        6: 'Juni',
        7: 'Juli',
        8: 'August',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'Dezember',
      },
    },
    nl: {
      base: {
        introtext: 'Hallo wereld',
      }
    }
  }
});